import { render, staticRenderFns } from "./order-attendances-table-modal.vue?vue&type=template&id=0a48ebc2&scoped=true"
import script from "./order-attendances-table-modal.vue?vue&type=script&lang=js"
export * from "./order-attendances-table-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48ebc2",
  null
  
)

export default component.exports